import { ReceiptContainerModel, TYPE_SEARCH } from 'shared';
import { PaginateQuery, PaginatorModel } from 'symbols';

export class GetTrafficList {
  static type = '[receipt] GetTrafficList';

  constructor(public lazy: boolean, public filter?: PaginateQuery<{ searchText: string, typeSearch: TYPE_SEARCH }>) {
  }
}

export class GetTrafficListSuccess {
  static type = '[receipt] GetTrafficListSuccess';

  constructor(public receiptList: PaginatorModel<ReceiptContainerModel>, public lazy: boolean) {
  }
}

export class GetTrafficListError {
  static type = '[receipt] GetTrafficListError';

  constructor(public error: any) {
  }
}


export class ClearScrollPositionTrafficList {
  static type = '[receipt] ClearScrollPositionTrafficList';
}

export class UpdateScrollPositionTrafficList {
  static type = '[receipt] UpdateScrollPositionTrafficList';

  constructor(public position: number) {
  }
}

export class SetLastOpenedTrafficId {
  static type = '[receipt] SetLastOpenedTrafficId';

  constructor(public trafficId: string) {
  }
}
